export const LOGIN = (state) => {
  state.pending = true
}

export const LOGIN_SUCCESS = (state, data) => {
  state.isLoggedIn = true
  state.token = data.token
  state.username = data.username
  state.name = data.username
  state.email = data.email
  state.phone = data.phone
  state.roles = data.roles
  state.pending = false
}

export const LOGIN_FAIL = (state) => {
  state.pending = false
  state.isLoggedIn = false
  state.username = ''
  state.name = ''
  state.email = ''
  state.phone = ''
  state.roles = []
  state.token = ''
}

export const LOGOUT = (state) => {
  state.isLoggedIn = false
  state.token = ''
  state.username = ''
  state.name = ''
  state.email = ''
  state.phone = ''
  state.roles = []
  state.pending = false
}
